/* Created by Interactive 63 - https://interactive63.com */
/**
 * Editor actions for live text: adding a text layer and changing a text element's content, font
 * and alignment. Typing and scrubbing pass a coalesce key so a burst of edits is one undo step.
 */
import type { ElementId } from '../../core/model/types';
import { addTextLayer, setTextContent, setTextStyle, type TextStyle } from '../../core/text/text';
import { requestTextEditing } from '../text-editing';
import { selectElements } from './actions';
import type { Store } from './store';

/** Adds a text layer in the middle of the artboard, selects it and returns its ID. */
export function addText(store: Store): ElementId {
  let id = '';
  store.updateProject('Add text', (draft) => {
    id = addTextLayer(draft);
  });
  selectElements(store, [id]);
  return id;
}

/** Adds a text layer and puts the cursor in its content field, ready to type over. */
export function addTextAndEdit(store: Store): ElementId {
  const id = addText(store);
  requestTextEditing();
  return id;
}

/** Replaces a text element's content. */
export function editTextContent(
  store: Store,
  id: ElementId,
  content: string,
  coalesceKey?: string,
): void {
  store.updateProject(
    'Edit text',
    (draft) => {
      setTextContent(draft, id, content);
    },
    coalesceKey ? { coalesceKey } : undefined,
  );
}

/** Changes a text element's font or alignment. */
export function editTextStyle(
  store: Store,
  id: ElementId,
  patch: Partial<TextStyle>,
  coalesceKey?: string,
): void {
  store.updateProject(
    'Change text style',
    (draft) => {
      setTextStyle(draft, id, patch);
    },
    coalesceKey ? { coalesceKey } : undefined,
  );
}
